const AUTH_NEXT_STORAGE_KEY = 'mphelper.auth.next'

export function getSafeAuthRedirect(value?: string | null): string | null {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return null
  if (trimmed.startsWith('/login') || trimmed.startsWith('/signup') || trimmed.startsWith('/auth/callback')) return null
  return trimmed
}

export function getStoredAuthRedirect(): string | null {
  try {
    return getSafeAuthRedirect(window.sessionStorage.getItem(AUTH_NEXT_STORAGE_KEY))
  } catch {
    return null
  }
}

export function setStoredAuthRedirect(value?: string | null) {
  const safeValue = getSafeAuthRedirect(value)
  try {
    if (safeValue) {
      window.sessionStorage.setItem(AUTH_NEXT_STORAGE_KEY, safeValue)
    } else {
      window.sessionStorage.removeItem(AUTH_NEXT_STORAGE_KEY)
    }
  } catch {
    // Auth still works without sessionStorage; the query param remains the source of truth.
  }
}

export function consumeStoredAuthRedirect(): string | null {
  const value = getStoredAuthRedirect()
  try {
    window.sessionStorage.removeItem(AUTH_NEXT_STORAGE_KEY)
  } catch {
    // Ignore storage failures.
  }
  return value
}

export function getAuthRedirectFromSearch(search = window.location.search): string | null {
  return getSafeAuthRedirect(new URLSearchParams(search).get('next'))
}

export function getPendingAuthRedirect(search = window.location.search): string | null {
  return getAuthRedirectFromSearch(search) || getStoredAuthRedirect()
}

export function buildAuthPath(path: string, next?: string | null): string {
  const safeNext = getSafeAuthRedirect(next)
  if (!safeNext) return path
  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}next=${encodeURIComponent(safeNext)}`
}
